module.exports = __webpack_public_path__ + "static/media/992330.6b914c3b.png";